interface Props {
  remainingSeconds: number;
  onExtend: () => void;
  onLogout: () => void;
}

export default function IdleTimeoutDialog({ remainingSeconds, onExtend, onLogout }: Props) {
  const min = Math.floor(remainingSeconds / 60);
  const sec = remainingSeconds % 60;
  const timeText = min > 0 ? `${min}분 ${sec}초` : `${sec}초`;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-xl p-6 shadow-xl max-w-sm w-full mx-4">
        <h3 className="text-lg font-semibold text-gray-900 mb-2">세션 만료 경고</h3>
        <p className="text-sm text-gray-600 mb-1">
          <span className="font-bold text-red-600">{timeText}</span> 후 자동 로그아웃됩니다.
        </p>
        <p className="text-sm text-gray-500 mb-6">
          계속 사용하시려면 [세션 연장]을 눌러주세요.
        </p>
        <div className="flex gap-3 justify-end">
          <button onClick={onLogout}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-lg hover:bg-gray-300 transition-colors">
            로그아웃
          </button>
          <button onClick={onExtend}
            className="px-4 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg hover:bg-gray-800 transition-colors">
            세션 연장
          </button>
        </div>
      </div>
    </div>
  );
}
